import React from 'react';
import { OptionProps, GroupBase } from 'react-select';
import { File } from 'v2/models';
import { getFileDepth } from 'v2/common/DRM/FilePath/getPartsToDisplay';
import { SelectOption } from '../../MultiFilterDropdown';
import styles from './FileOption.module.scss';
import { Tabulation } from './Tabulation';
import classnames from 'classnames';
import OptionComponent from '../OptionComponent';
import fileIcon from 'v2/icons/file-small.svg';
import { useCurrentFileTree } from './CurrentFileTree';

export function getIsParentFolderCollapsed(
  parts: string[],
  collapsedFolders: Set<string>
) {
  while (parts.length) {
    parts.splice(parts.length - 1, 1);
    const parentDir = parts.join('/');
    if (collapsedFolders.has(parentDir)) {
      return true;
    }
  }
  return false;
}

interface ITabulatedFileNameProps extends SelectOption<File> {
  children?: React.ReactNode;
}

function TabulatedFileName({ value: file }: ITabulatedFileNameProps) {
  const { depth } = getFileDepth(file.name, file.relative_path);
  return (
    <div className={classnames(styles.file)} title={file.name}>
      <Tabulation count={depth} />
      <img src={fileIcon} alt="file" />
      <span className={styles.filename}>{file.name}</span>
    </div>
  );
}

export function FileOption<T extends File>(
  props: OptionProps<SelectOption<T>, true, GroupBase<SelectOption<T>>>
) {
  const file = props.data.value;
  const { parts } = getFileDepth(file.name, file.relative_path);
  const { collapsedFolders } = useCurrentFileTree();
  const isParentCollapsed = getIsParentFolderCollapsed(parts, collapsedFolders);
  return isParentCollapsed ? null : (
    <OptionComponent {...props} LabelComponent={TabulatedFileName} />
  );
}
